export default "__VITE_ASSET__D5gLMF8B__"